import styled from 'styled-components';
import { DropDown } from '@elementary/common-ui/components';
import { capitalize } from '@elementary/common-ui/utils/common';
import { QualityDimension } from 'shared/types';
import { QUALITY_DIMENSIONS } from './constants';
import FieldRow from './FieldRow';

const Link = styled.a`
  color: ${({ theme }) => theme.palette.common.blue4};
  text-decoration: underline;
`;

type Props = {
  onChange: (value?: QualityDimension) => void;
  value?: QualityDimension;
};

const QualityDimensionSelector = ({ onChange, value }: Props) => (
  <FieldRow
    label="Quality dimension:"
    info={
      <p>
        The selected quality dimension will be used to feature this test in the{' '}
        <Link href="https://docs.elementary-data.com/features/collaboration-and-communication/data-health">
          data health score
        </Link>{' '}
        calculations
      </p>
    }
  >
    <DropDown
      sx={{ flex: 1, minWidth: 0, width: '100%' }}
      size="large"
      showClear
      placeholder="Select a quality dimension"
      options={QUALITY_DIMENSIONS.map((v) => ({
        label: capitalize(v),
        value: v,
      }))}
      onChange={(v) =>
        onChange(QUALITY_DIMENSIONS.find((dimension) => dimension === v))
      }
      value={value}
    />
  </FieldRow>
);

export default QualityDimensionSelector;
